import { AnimatePresence, m } from "framer-motion";
import { useAtom } from "jotai";

import { navDesktopDropdownOpenAtom } from "@theme/components";

import type { FC } from "react";

/**
 * Product Dropdown Underlay
 *
 * Design requested that when desktop dropdown is open
 *
 * we have an underlay to have users focus on the dropdown instead
 *
 */
export const NavDesktopUnderlay: FC = () => {
  const [isDesktopDropdownOpen] = useAtom(navDesktopDropdownOpenAtom);

  return (
    <AnimatePresence>
      {isDesktopDropdownOpen && (
        <m.div
          initial="hide"
          animate="show"
          exit="hide"
          variants={{
            hide: { opacity: 0 },
            show: { opacity: 1 },
          }}
          sx={{
            display: ["none", null, null, "block"],
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 998,
            pointerEvents: "none",
            background: "rgba(0, 0, 0, 0.75)",
          }}
        />
      )}
    </AnimatePresence>
  );
};
